/**
 * Application-wide constants
 */

/**
 * System tenant name - this tenant has unlimited access and special privileges.
 * Used for the Scopic organization which manages the system.
 */
export const SYSTEM_TENANT_NAME = "Scopic";

/**
 * Bump this value to force all clients to invalidate their localStorage reference data cache (locations + languages).
 */
export const REF_DATA_VERSION = "1";

/**
 * Number of cluster replacements remaining at or below which a quota warning is shown before deleting a cluster.
 */
export const LOW_REPLACEMENT_QUOTA_THRESHOLD = 3;
